import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { IconModule } from '@spartacus/storefront';
import { SelectComponent } from './select.component';

@NgModule({
  declarations: [SelectComponent],
  imports: [IconModule],
  exports: [SelectComponent, NgSelectModule],
})
export class SdvorSelectModule {}
